import styled from "@emotion/styled";
import Card from "components/Card";
import { Table, TableCell, TableHeaderCell } from "components/Table";
import { colors, margins } from "style";

const LegacyHeaderCell = styled(TableHeaderCell)`
  background: ${(props) => props.highlightColor || colors.grayAnatomyLight5};
  border-bottom: 2px solid ${(props) => props.highlightColor || colors.grayAnatomyLight4};
  border-right: 1px solid ${(props) => props.highlightColor || colors.grayAnatomyLight4};
  padding: ${margins.xxsmall};
  font-weight: 600;
  text-align: left;
  white-space: normal;
  word-break: break-word;
  min-width: ${(props) => props.width}px;
  max-width: ${(props) => props.width}px;
  width: ${(props) => props.width}px;

  &:first-of-type {
    position: sticky;
    left: 0;
    z-index: 4;
    background: ${colors.grayAnatomyLight5};
  }

  &:not(:first-of-type) {
    text-align: center;
    z-index: 3;
  }

  &:last-of-type {
    border-right: none;
  }
`;

const LegacyDataCell = styled(TableCell)`
  border-bottom: 1px solid ${(props) => props.highlightColor || colors.grayAnatomyLight4};
  border-right: 1px solid ${(props) => props.highlightColor || colors.grayAnatomyLight4};
  padding: 0;
  vertical-align: middle;
  min-width: ${(props) => props.width}px;
  max-width: ${(props) => props.width}px;
  width: ${(props) => props.width}px;
  height: 1rem;

  ${({ highlightColor }) => highlightColor && `background: ${highlightColor};`}

  &:first-of-type {
    position: sticky;
    left: 0;
    z-index: 4;
    background: ${colors.grayAnatomyLight5};
    padding-left: 0rem;
  }

  &:last-of-type {
    border-right: none;
    padding-right: 0;
  }
`;

const AddResourceContainer = styled.div`
  padding: ${margins.xsmall};
  border-top: 1px solid ${colors.grayAnatomyLight4};
  background: ${colors.grayAnatomyLight5};
`;

const MemberCellContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: ${margins.xsmall};
  padding-right: ${margins.xsmall};
  gap: ${margins.small};

  > * {
    margin-top: 0 !important;
  }
`;

const LegacyTable = styled(Table)`
  margin-left: 0;
  width: 100%;
  min-width: max-content;
  border-collapse: separate;
  border-spacing: 0;
`;

const LegacyCard = styled(Card)`
  overflow: visible;
  margin-bottom: ${margins.normal};
`;

const LegacyTableWrapper = styled.div`
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.grayAnatomyLight5};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.grayAnatomyLight3};
    border-radius: 4px;

    &:hover {
      background: ${colors.grayAnatomyLight2};
    }
  }
`;

export {
  LegacyHeaderCell,
  LegacyDataCell,
  AddResourceContainer,
  MemberCellContent,
  LegacyTable,
  LegacyCard,
  LegacyTableWrapper,
};
